import {
  ExportBatchAssetsBody,
  MappingDataForExportPortal,
  PortalData,
} from "shared/types/assetExporter";
import { User } from "redux/auth/auth.slice";
import {
  AdInfoUpdates,
  AdType,
  ExportDestination,
  RecommendedColumnMatches,
} from "../types";
import { IFilter } from "shared/hooks/assetExporter/useFeedConfigFetch";

interface GetExportAssetBatchesBody {
  selectedRows: string[];
  selectedAssetBatches: string[];
  feedId: string;
  exportDestination: ExportDestination;
  user: User;
  columnMatches?: RecommendedColumnMatches;
  adInfoUpdates?: AdInfoUpdates;
  adType?: AdType | null;
  portalOptionMatches?: MappingDataForExportPortal;
  portalData?: PortalData;
  filterArgs?: IFilter[];
  searchValue?: string;
  selectAll: boolean;
}

export const getExportAssetBatchesBody = ({
  selectedRows,
  selectedAssetBatches,
  feedId,
  user,
  exportDestination,
  columnMatches,
  adInfoUpdates,
  adType,
  portalOptionMatches,
  portalData,
  filterArgs,
  searchValue,
  selectAll,
}: GetExportAssetBatchesBody): ExportBatchAssetsBody => {
  const baseExportBody: ExportBatchAssetsBody = {
    feedId,
    createdBy: user.email,
    selectedRows: selectedRows,
    assetBatchIds: selectedAssetBatches,
    exportType: exportDestination,
    filters: filterArgs,
    search: searchValue,
    selectAll,
  };

  if (exportDestination === ExportDestination.AdLibrary && adType) {
    return {
      ...baseExportBody,
      columnMatches,
      adType,
      updates: adInfoUpdates,
    };
  } else if (
    exportDestination === ExportDestination.GoogleSpreadsheet &&
    portalOptionMatches
  ) {
    return {
      ...baseExportBody,
      mappingDataForExportPortal: portalOptionMatches,
      instanceName: process.env.REACT_APP_AV2_CLIENT,
    };
  } else if (exportDestination === ExportDestination.Portal) {
    return {
      ...baseExportBody,
      portalData,
    };
  } else return baseExportBody;
};
